<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed"></i>
        巡查人员管理
      </div>
      <!--            <div class="common-page common-head-end" @click="$router.back()">-->
      <!--                <i class="icon-tr-sign-out"></i>-->
      <!--            </div>-->
    </div>
    <!-- <ul class="tab-wrap" style="border:none" >
      <li
        :class="`tab-btn ${nowIndex == index && 'active'}`"
        @click="changeTab(index,tab)"
        v-for="(tab, index) in tabList"
      >
        {{tab.name }}
      </li>
    </ul> -->
    <div class="common-page common-body commonBtn">
      <div class="common-page common-tool-bar btnLeft">
        <div v-hasPermi="['safe:user:query']" class="btn" @click="showDia = true"><i class="icon-tr-search"></i>查询</div>
        <router-link
          v-hasPermi="['safe:user:add']"
          class="btn ml20"
          :to="{
            path: '/safe/safe-adduser',
            query: { inspection: tabList[nowIndex].id == 0 ? 1 : 2 },
          }"
        >
          <i class="icon-tr-newly-added"> </i> 新增</router-link
        >
      </div>
      <div class="common-page common-list">
        <el-table :data="list" class="" v-loading="loading">
          <el-table-column prop="userName" label="登录账号" align="center"> </el-table-column>
          <el-table-column prop="nickName" align="center" label="真实姓名"> </el-table-column>
          <el-table-column prop="phonenumber" align="center" label="手机号"> </el-table-column>
          <el-table-column align="center" label="巡查区域">
            <template slot-scope="scope">
              {{ scope.row.xCompanyArea == 'null' ? '暂无数据' : scope.row.xCompanyArea }}
            </template>
          </el-table-column>
          <el-table-column prop="STATUS" align="center" label="标签类型">
            <template slot-scope="scope">
              {{ $map.NFCStatus[scope.row.xcNfc] }}
            </template>
          </el-table-column>
          <el-table-column prop="STATUS" align="center" label="巡查类型" v-if="!this.$store.state.user.userInfo.isWenwu">
            <template slot-scope="scope">
              <!-- {{ $map.NFCStatus[scope.row.xcPerson] }} -->
              <div v-if="scope.row.xcPerson == 4">自查</div>
              <div v-if="scope.row.xcPerson == 1">巡查</div>
              <div v-if="scope.row.xcPerson == 5">巡查和自查</div>

            </template>
          </el-table-column>
          <el-table-column prop="STATUS" align="center" label="状态">
            <template slot-scope="scope">
              {{ $map.menuStatus[scope.row.status] }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="160px">
            <template slot-scope="scope">
              <router-link
                v-hasPermi="['safe:user:edit']"
                :to="{
                  path: '/safe/safe-adduser',
                  query: {
                    id: scope.row.userId,
                    inspection: tabList[nowIndex].id == 0 ? 1 : 2,
                  },
                }"
              >
                <el-button type="warning" size="mini">编辑</el-button>
              </router-link>
              <el-popconfirm title="确定此删除该单位吗？" class="cursor" v-hasPermi="['safe:user:remove']" @confirm="changeStatus(scope.row)" @onConfirm="changeStatus(scope.row)">
                <a slot="reference" class="red" v-if="scope.row.status == 1">
                  <el-button type="danger" size="mini">删除</el-button>
                </a>
                <a slot="reference" class="blue" v-if="scope.row.status != 1">
                  开启
                </a>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
        <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm" v-if="tabList[nowIndex].id == 0"> </fm-generate-form>
        <fm-generate-form :data="searchForm1" :remote="remoteFuncs" :value="editData" v-if="tabList[nowIndex].id == 1" ref="searchForm"> </fm-generate-form>
        <div class="center">
          <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
          <el-button @click="cancle" size="small">重置</el-button>
        </div>
      </el-dialog>
    </div>
    <div style="margin-right: .9375rem;">
      <el-pagination background layout="prev, pager, next" :page-size="params.limit || 10" @current-change="pageChange" :total="total"> </el-pagination>
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="params.limit || 10"
        layout=" prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      tabList: this.$store.state.user.userInfo.isWenwu ? [{ name: '文物巡查', id: 1 }] : [{ name: '消防巡查', id: 0 }],

      nowIndex: 0,
      params: {
        page: 1,
        limit: 10,
        userName: '',
        nickName: '',
        xCompanyArea: '',
        inspectionType: 1,
      },
      total: 0,
      showDia: false,
      loading:true,
      searchForm: this.$getForm('userSearch1'),
      searchForm1: this.$getForm('userSearchww'),
      allData: null,
      editData: {},
      remoteFuncs: {
        _this: this,
        getArea(resolve) {
          var _this = this._this;
          _this
            .$post('/xuncha/xunchaareadetail', {
              c_company_num: _this.$store.state.user.company.cCompanyNum,
            })
            .then((res) => {
              console.log(res);
              resolve(res.data);
            });
        },
        getWWArea(resolve) {
          var _this = this._this;
          _this
            .$post('/xuncha/xunchaareadetailWenWu', {
              c_company_num: _this.$store.state.user.company.cCompanyNum,
            })
            .then((res) => {
              resolve(res.data);
            });
        },
      },
    };
  },
  created() {
    console.log(this.$store.state.user.userInfo.isWenwu,3333333);
    this.params.inspectionType = this.tabList[this.nowIndex].id == 0 ? 1 : 2;
    this.getList();
  },
  methods: {
    cancle() {
      // this.showDia=false
      this.resetSearch();
    },
    changeTab(index, it) {
      this.nowIndex = index;
      this.params = {
        currentpage: 1,
        userName: '',
        nickName: '',
        xCompanyArea: '',
        inspectionType: this.tabList[this.nowIndex].id == 0 ? 1 : 2,
      };
      this.getList();
    },
    changeStatus(it, del) {
      console.log(it,666);
      let status = it.status == 1 ? 0 : 1;
      if (del) status = del;
      this.$remove('/user/delUser?userId='+it.userId).then(res=>{
        this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
        this.getList();
      })
      // this.$post('/user/updateuserstatus', {
      //   user_id: it.user_id,
      //   status: status,
      // }).then((res) => {
      //   this.$message({
      //           message: '操作成功',
      //           type: 'success',
      //           duration: 700,
      //         });
      //   this.getList();
      // });
    },

    getList() {
      // getUserList(this.params).then(res=>{
      //     this.total = res.data.count
      //     this.list = res.data.list
      // }).catch(err=>{
      // })
      this.loading=true
      this.$post('/patrol/xcpersonlist', this.params).then((res) => {
        console.log(res)
        this.total = res.total;
        this.list = res.rows;
        this.loading=false
      });
    },
    pageChange(index) {
      log(index);
      this.params.page = index;
      this.params.inspectionType = this.tabList[this.nowIndex].id == 0 ? 1 : 2;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style scoped>
.container-list {
  width: 100%;
  height: 100%;
}
.common-tool-bar {
  width: 100%;
  display: flex;
}
.btnLeft {
  margin: 0 -40px;
}
</style>
